/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-09 11:12:36
 *
 *******************************************************/
// @flow

import { Toast } from '@shopify/app-bridge/actions';
import { getSABAppInstance_Normal } from './app';

/**
 * Show toast message
 * @param  {string} message message to show
 * @param  {boolean} isError error option
 */
export const showSABToast = (message: string, isError: boolean = false) => {
  const toastOptions = {
    message: message,
    duration: 5000,
    isError: isError
  };
  const toastNotice = Toast.create(getSABAppInstance_Normal(), toastOptions);
  toastNotice.dispatch(Toast.Action.SHOW);
};
